import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
  const [mode, setMode] = useState('customer');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [step, setStep] = useState('phone');
  const [msg, setMsg] = useState('');
  const nav = useNavigate();

  const requestOtp = async () => {
    setMsg('');
    try {
      await api.post('/auth/otp/request', { phone });
      setStep('otp');
      setMsg('Code sent — check your phone (or backend console in dev)');
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const verifyOtp = async () => {
    try {
      const res = await api.post('/auth/otp/verify', { phone, code: otp });
      localStorage.setItem('sdx_token', res.data.token);
      localStorage.setItem('sdx_user', JSON.stringify(res.data.user));
      nav('/book');
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const staffLogin = async () => {
    try {
      const res = await api.post('/auth/staff-login', { phone, password });
      localStorage.setItem('sdx_token', res.data.token);
      localStorage.setItem('sdx_user', JSON.stringify(res.data.user));
      nav('/hub/inbox');
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <button className="btn" style={{ flex: 1, background: mode === 'customer' ? '#dc2626' : '#f3f4f6', color: mode === 'customer' ? '#fff' : '#374151' }} onClick={() => setMode('customer')}>Customer</button>
          <button className="btn" style={{ flex: 1, background: mode === 'staff' ? '#dc2626' : '#f3f4f6', color: mode === 'staff' ? '#fff' : '#374151' }} onClick={() => setMode('staff')}>Staff</button>
        </div>
        {mode === 'customer' ? (
          step === 'phone' ? (
            <>
              <label className="label">Phone number</label>
              <input className="input" placeholder="260971234567" value={phone} onChange={e => setPhone(e.target.value)} />
              <button className="btn btn-primary" onClick={requestOtp}>Send Code</button>
            </>
          ) : (
            <>
              <label className="label">Enter 6-digit code</label>
              <input className="input" value={otp} onChange={e => setOtp(e.target.value)} />
              <button className="btn btn-primary" onClick={verifyOtp}>Verify</button>
            </>
          )
        ) : (
          <>
            <label className="label">Phone</label>
            <input className="input" value={phone} onChange={e => setPhone(e.target.value)} />
            <label className="label">Password</label>
            <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} />
            <button className="btn btn-primary" onClick={staffLogin}>Sign In</button>
          </>
        )}
        {msg && <p style={{ marginTop: 12, color: '#6b7280', fontSize: 13 }}>{msg}</p>}
      </div>
    </div>
  );
}
